import {GET} from '../constants/API_CONSTANTS';
import {request} from '../utils/request';
import {API_GET_MENU_ITEMS} from '../constants/API_ENDPOINTS';

const getServiceMenuItemsApi = async () => {
  // Global catalog, not scoped to the active location.
  return request(GET, API_GET_MENU_ITEMS(), null, {ignoreLocationEpoch: true});
};

export default getServiceMenuItemsApi;
